import { shallowEqual, TypedUseSelectorHook, useSelector } from 'react-redux';
import { State } from '../redux/root.reducer';

export const useAppSelector: TypedUseSelectorHook<State> = (
  selector,
) => useSelector(selector, shallowEqual);
